<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="オプション契約参照"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  color="primary"
                  v-permission.admin
                  @click="showOptionModify"
                  >変更</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="対象V番号"
                  :value="user.contractInfo.vnumber"
                />
              </v-col>
            </v-row>
            <template v-if="contractOption.additionalLogCapacity !== null">
              <v-row>
                <v-col cols="12">
                  <app-label-group label="追加ログ保存容量">
                    <template #value>
                      <template
                        v-if="contractOption.additionalLogCapacity !== 0"
                      >
                        <div>
                          <span class="ml-3">
                            {{
                              `ログ保存容量設定 ${
                                contractOption.additionalLogCapacity + 10
                              }GB`
                            }}
                          </span>
                        </div>
                      </template>
                      <div>
                        <span class="ml-3">
                          <template
                            v-if="contractOption.additionalLogCapacity === 0"
                          >
                            OFF
                          </template>
                          <template v-else>
                            {{ `ON ${contractOption.additionalLogCapacity}GB` }}
                          </template>
                        </span>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
            </template>
            <template v-if="contractOption.isAllowLog !== null">
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="Allowログ"
                    :value="$filter.enumTo(contractOption.isAllowLog, 'on_off')"
                  />
                </v-col>
              </v-row>
            </template>
            <template v-if="contractOption.isStatistics !== null">
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="統計情報レポート"
                    :value="
                      $filter.enumTo(contractOption.isStatistics, 'on_off')
                    "
                  />
                </v-col>
              </v-row>
            </template>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { ContractChangeOption } from "@/apis/ContractChangeOptionApi";
import ContractOptionModify from "@/modals/applianceContractSetting/options/ContractOptionModify.vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "ContractOptionReference",
  data() {
    return {
      /** 初期通信完了フラグ */
      isLoaded: false,
      /** ユーザ設定 */
      user: this.$store.state.user,
      contractOption: {} as ContractChangeOption,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** データ取得 */
    async load() {
      this.contractOption =
        await this.$api.contractChangeOption.getContractOptions();
    },
    /** オプション契約変更モーダルを表示 */
    async showOptionModify() {
      await this.$modal.show(ContractOptionModify, {
        contractOption: this.contractOption,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
